<!-- Page body start -->
<div class="page-body">
    <div class="row">
        <div class="col">
            <!-- Basic Form Inputs card start -->
            <div class="card">
                <div class="card-block">
                    <form (ngSubmit)="guardarPersona(formPersona)" #formPersona="ngForm">
                        <div class="form-group row">
                            <div class="col" *ngIf="persona.TipoPersona == 2">
                                <label for="PersonalidadFiscalId">Personalidad Fiscal</label>
                                <select class="form-control" name="PersonalidadFiscalId"
                                    (change)="cambioPersonalidad($event.target.value,persona.TipoPersona)"
                                    [(ngModel)]="persona.Persona.PersonalidadFiscalId" required #personalidad="ngModel"
                                    [ngClass]="{ 'is-invalid': personalidad.value == -1 || personalidad.errors?.required,
        'is-valid': personalidad.value > -1  || !personalidad.errors?.required}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ pFiscal.personalidadFiscalId }}"
                                        *ngFor="let pFiscal of personalidadFiscal">{{ pFiscal.personalidadFiscal }}
                                    </option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf="personalidad.value == -1 || personalidad.errors?.required">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>

                            <div class="col" *ngIf="persona.TipoPersona == 2">
                                <div class="form-group">
                                    <label>Número de Cliente</label>
                                    <input type="text" class="form-control" placeholder="Número de Cliente"
                                        name="ClaveCia" [(ngModel)]="persona.Persona.ClaveCia" required
                                        #ClaveCia="ngModel" 
                                        [ngClass]="{ 'is-invalid': ClaveCia.errors?.required,
                                                     'is-valid': !ClaveCia.errors?.required }" 
                                        maxlength="30">
                                    <div class="invalid-feedback" *ngIf="ClaveCia.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                </div>
                            </div>

                            <div class="col" *ngIf="persona.TipoPersona == 1">
                                <div class="form-group">
                                    <label>Número de Empleado</label>
                                    <input type="text" class="form-control" placeholder="Número de Empleado"
                                        name="ClaveCia" [(ngModel)]="persona.Persona.ClaveCia" required
                                        #ClaveCia="ngModel" [ngClass]="{ 'is-invalid': ClaveCia.errors?.required,
                'is-valid': !ClaveCia.errors?.required}" />
                                    <div class="invalid-feedback" *ngIf="ClaveCia.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                </div>
                            </div>

                            <div class="col">
                                <label for="EstatusId">Estatus</label>
                                <select class="form-control" name="EstatusId" id="EstatusId"
                                    [(ngModel)]="persona.Persona.EstatusId" required #EstatusId="ngModel" [ngClass]="{ 'is-invalid': EstatusId.errors?.required || EstatusId.value == -1,
                                'is-valid': !EstatusId.errors?.required || EstatusId.value != -1}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ es.estatusId }}" *ngFor="let es of estatus">{{ es.estatus }}
                                    </option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf=" EstatusId.errors?.required || EstatusId.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>
                        </div>

                        <div class="form-group row" *ngIf="persona.Persona.PersonalidadFiscalId == 2 ">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="Nombre">Razón Social</label>
                                    <input type="text" id="Nombre" class="form-control" placeholder="Razón Social"
                                        name="Nombre" [(ngModel)]="persona.Persona.Nombre" required #Nombre="ngModel"
                                        [ngClass]="{ 'is-invalid': Nombre.errors?.required,
                'is-valid': !Nombre.errors?.required }" maxlength="254"/>
                                    <div class="invalid-feedback" *ngIf="Nombre.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row"
                            *ngIf="persona.Persona.PersonalidadFiscalId == 1 || persona.Persona.PersonalidadFiscalId == 3 || persona.Persona.PersonalidadFiscalId == 0">
                            <div class="col">
                                <div class="form-group">
                                    <label>Nombre</label>
                                    <input type="text" class="form-control" maxlength="200" placeholder="Nombre" name="Nombre"
                                        [(ngModel)]="persona.Persona.Nombre" required #Nombre="ngModel" [ngClass]="{ 'is-invalid': Nombre.errors?.required,
                'is-valid': !Nombre.errors?.required }" maxlength="200" (blur)="blurEvent()"/>
                                    <div class="invalid-feedback" *ngIf="Nombre.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Segundo Nombre</label>
                                    <input type="text" class="form-control" maxlength="200" placeholder="Segundo Nombre" name="SNombre"
                                        [(ngModel)]="persona.Persona.SNombre" maxlength="200" (blur)="blurEvent()"/>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Apellido Paterno</label>
                                    <input type="text" class="form-control" maxlength="200" placeholder="Apellido Paterno"
                                        name="ApellidoPaterno" [(ngModel)]="persona.Persona.ApellidoPaterno" required
                                        #ApellidoPaterno="ngModel"
                                        pattern="[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{2,64}"
                                        [ngClass]="{ 'is-invalid': ApellidoPaterno.errors?.required || ApellidoPaterno.errors?.pattern,
                                    'is-valid': !ApellidoPaterno.errors?.required || !ApellidoPaterno.errors?.pattern }" maxlength="200" (blur)="blurEvent()"/>
                                    <div class="invalid-feedback" *ngIf="ApellidoPaterno.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                    <div class="invalid-feedback" *ngIf="ApellidoPaterno.errors?.pattern">
                                        El formato es incorrecto
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col"
                                *ngIf="persona.Persona.PersonalidadFiscalId == 1 || persona.Persona.PersonalidadFiscalId == 3 || persona.Persona.PersonalidadFiscalId == 0">
                                <div class="form-group">
                                    <label>Apellido Materno</label>
                                    <input type="text" class="form-control" maxlength="200" placeholder="Apellido Materno"
                                        name="ApellidoMaterno" [(ngModel)]="persona.Persona.ApellidoMaterno" required
                                        #ApellidoMaterno="ngModel"
                                        pattern="[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{2,64}"
                                        [ngClass]="{ 'is-invalid': ApellidoMaterno.errors?.required || ApellidoMaterno.errors?.pattern,
                'is-valid': !ApellidoMaterno.errors?.required || !ApellidoMaterno.errors?.pattern }" maxlength="200" (blur)="blurEvent()"/>
                                    <div class="invalid-feedback" *ngIf="ApellidoMaterno.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                    <div class="invalid-feedback" *ngIf="ApellidoMaterno.errors?.pattern">
                                        El formato es incorrecto
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <label for="exampleSelect1">País</label>
                                <select class="form-control" name="PaisId" [(ngModel)]="PaisId"
                                    (change)="seleccionarEstado($event.target.value)" required #Pais="ngModel"
                                    [ngClass]="{ 'is-invalid': Pais.errors?.required || Pais.value == -1,
            'is-valid': !Pais.errors?.required || Pais.value != -1}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ p.paisId }}" *ngFor="let p of paises">{{
                p.pais
              }}</option>
                                </select>
                                <div class="invalid-feedback" *ngIf="Pais.errors?.required || Pais.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>
                            <div class="col">
                                <label for="exampleSelect1">Estado</label>
                                <select class="form-control" name="EstadoId" [(ngModel)]="persona.Persona.EstadoId"
                                    required #EstadoId="ngModel" [ngClass]="{ 'is-invalid': EstadoId.errors?.required || EstadoId.value == -1,
            'is-valid': !EstadoId.errors?.required || EstadoId.value != -1}" (blur)="blurEvent()">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ estado.estadoId }}" *ngFor="let estado of estados">
                                        {{ estado.estado }}</option>
                                </select>
                                <div class="invalid-feedback" *ngIf="EstadoId.errors?.required || EstadoId.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col">
                                <div class="form-group">
                                    <label>Nacionalidad</label>
                                    <input type="text" class="form-control" placeholder="Nacionalidad"
                                        [(ngModel)]="Nacionalidad" [disabled]="true"
                                        [ngModelOptions]="{ standalone: true }" />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label
                                        *ngIf="persona.Persona.PersonalidadFiscalId == 1 || persona.Persona.PersonalidadFiscalId == 3 || persona.Persona.PersonalidadFiscalId == 0 || persona.Persona.PersonalidadFiscalId == -1">Fecha
                                        de Nacimiento</label>
                                    <label *ngIf="persona.Persona.PersonalidadFiscalId == 2 ">Fecha de
                                        Constitución</label>
                                    <input type="date" class="form-control" name="FechaNacimiento"
                                        [(ngModel)]="persona.Persona.FechaNacimiento" required
                                        #FechaNacimiento="ngModel" [ngClass]="{ 'is-invalid': FechaNacimiento.errors?.required || FechaNacimiento.errors?.maxlength,
                'is-valid': !FechaNacimiento.errors?.required || !FechaNacimiento.errors?.maxlength }"
                                        maxlength="10" (blur)="blurEvent()"/>
                                    <div class="invalid-feedback" *ngIf="FechaNacimiento.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                    <div class="invalid-feedback" *ngIf="FechaNacimiento.errors?.maxlength">
                                        La Fecha de Nacimiento es Incorrecta
                                    </div>
                                </div>
                            </div>


                            <div class="col">
                                <div class="form-group">
                                    <label>R.F.C</label>
                                    <input type="text" class="form-control" maxlength="13" placeholder="R.F.C" name="RFC"
                                        [(ngModel)]="persona.Persona.RFC" required #RFC="ngModel"
                                        (keyup)="validarRFC()"
                                        [ngClass]="{ 'is-invalid': RFC.errors?.required || formatoRFC,
                'is-valid': !RFC.errors?.required || !RFC.errors?.pattern}" />
                                    <div class="invalid-feedback" *ngIf="RFC.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                    <div class="invalid-feedback"  *ngIf="formatoRFC">
                                        El formato es incorrecto
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col"
                                *ngIf="persona.Persona.PersonalidadFiscalId == 1 || persona.Persona.PersonalidadFiscalId == 3 || persona.Persona.PersonalidadFiscalId == 0">
                                <div class="form-group">
                                    <label>C.U.R.P</label>
                                    <input type="text" class="form-control" placeholder="C.U.R.P" name="CURP"
                                        [(ngModel)]="persona.Persona.CURP" #CURP="ngModel" (keyup)="
                  persona.Persona.CURP = persona.Persona.CURP.toUpperCase()
                " pattern="([A-Z]{4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM](AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[A-Z]{3}[0-9A-Z]\d)$"
                                        [ngClass]="{ 'is-invalid':  CURP.errors?.pattern,
                'is-valid': !CURP.errors?.pattern && CURP.value != ''}" />
                                    <div class="invalid-feedback" *ngIf="CURP.errors?.pattern">
                                        El formato es incorrecto
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group"
                                    *ngIf="persona.Persona.PersonalidadFiscalId == 1 || persona.Persona.PersonalidadFiscalId == 3 || persona.Persona.PersonalidadFiscalId == 0">
                                    <label for="sexo">Sexo</label>
                                    <select class="form-control" name="SexoId" [(ngModel)]="persona.Persona.SexoId"
                                        required #sexo="ngModel" [ngClass]="{ 'is-invalid':  sexo.errors?.required || sexo.value == -1,
                'is-valid': !sexo.errors?.pattern} || sexo.value != -1" (blur)="blurEvent()">
                                        <option value="-1">Selecciona una Opción</option>
                                        <option value="{{ sexo.sexoId }}" *ngFor="let sexo of sexos">{{ sexo.sexo }}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback" *ngIf="sexo.errors?.required || sexo.value == -1">
                                        Debes Seleccionar una Opción
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group"
                                    *ngIf="persona.Persona.PersonalidadFiscalId == 1 || persona.Persona.PersonalidadFiscalId == 3 || persona.Persona.PersonalidadFiscalId == 0">
                                    <label for="EstadoCivilId">Estado Civil</label>
                                    <select class="form-control" name="EstadoCivilId" [(ngModel)]="persona.Persona.EstadoCivilId" 
                                        required #EstadoCivilId="ngModel"
                                        [ngClass]="{ 'is-invalid':  EstadoCivilId.errors?.required || EstadoCivilId.value == -1,
                'is-valid': !EstadoCivilId.errors?.pattern} || EstadoCivilId.value != -1">
                                        <option value="-1">Selecciona una Opción</option>
                                        <option value="{{ eCivil.estadoCivilId }}" *ngFor="let eCivil of estadosciviles">{{ eCivil.estadoCivil }}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback" *ngIf="EstadoCivilId.errors?.required || EstadoCivilId.value == -1">
                                        Debes Seleccionar una Opción
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col" *ngIf="
              persona.Persona.PersonalidadFiscalId == 1 || persona.Persona.PersonalidadFiscalId == 3 || persona.Persona.PersonalidadFiscalId == 0 &&
              persona.TipoPersona == 2
            ">
                                <div class="form-group">
                                    <label>Firma Electrónica</label>
                                    <input type="text" class="form-control" maxlength="300" placeholder="Firma Electrónica"
                                        [(ngModel)]="persona.Persona.FirmaElectronica" name="FirmaElectronica" maxlength="300"/>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Correo Electrónico</label>
                                    <input type="email" class="form-control" placeholder="Correo Electrónico"
                                        name="Correo" [(ngModel)]="persona.Persona.Correo" required #Correo="ngModel"
                                        pattern="[a-z0-9A-Z._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$" [ngClass]="{ 'is-invalid':  Correo.errors?.required || Correo.errors?.pattern,
                'is-valid': !Correo.errors?.pattern} || !Correo.errors?.pattern" minlength="5" maxlength="60"/>
                                    <div class="invalid-feedback" *ngIf="Correo.errors?.required || persona.Persona.Correo.length<5">
                                        Debes llenar este campo (con un mínimo de 5 y un máximo de 60 caracteres)
                                    </div>
                                    <div class="invalid-feedback" *ngIf="Correo.errors?.pattern">
                                        El formato es incorrecto
                                    </div>
                                </div>
                            </div>

                            <div class="col" *ngIf="persona.TipoPersona == 1">
                                <div class="form-group">
                                    <label>Fecha de Ingreso</label>
                                    <input type="date" class="form-control" placeholder="Fecha de Ingreso"
                                        name="FechaIngreso" [(ngModel)]="persona.Empleado.FechaIngreso" required
                                        #FechaIngreso="ngModel" [ngClass]="{ 'is-invalid':  FechaIngreso.errors?.required ,
                                      'is-valid': !FechaIngreso.errors?.required }" />
                                    <div class="invalid-feedback" *ngIf="FechaIngreso.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                </div>
                            </div>


                            <div class="col" *ngIf="persona.TipoPersona == 2">
                                <label for="exampleSelect1">Actividad Económica</label>
                                <select class="form-control" name="ActividadEId"
                                    [(ngModel)]="persona.Cliente.ActividadEId" required #Activeconomica="ngModel"
                                    [ngClass]="{ 'is-invalid':  Activeconomica.errors?.required || Activeconomica.value == -1,
                'is-valid': !Activeconomica.errors?.required || Activeconomica.value != -1}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ actividad.actividadEconomicaId }}"
                                        *ngFor="let actividad of actividades">{{ actividad.actividadEconomica }}
                                    </option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf="Activeconomica.errors?.required || Activeconomica.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>
                            <div class="col" *ngIf="persona.Persona.PersonalidadFiscalId == 2 && persona.TipoPersona == 2">
                                <label for="exampleSelect1">Giro</label>
                                <input type="text" class="form-control" placeholder="Giro" name="Giro"
                                    [(ngModel)]="persona.Cliente.Giro" required #Giro="ngModel" [ngClass]="{ 'is-invalid':  Giro.errors?.required || Giro.errors?.pattern,
                                'is-valid': !Giro.errors?.pattern} || !Giro.errors?.pattern" maxlength="100"/>
                                <div class="invalid-feedback" *ngIf="Giro.errors?.required ">
                                    Debes llenar este campo
                                </div>
                            </div>

                        </div>

                        <div class="form-group  row"
                            *ngIf="persona.Persona.PersonalidadFiscalId == 1 || persona.Persona.PersonalidadFiscalId == 3 || persona.Persona.PersonalidadFiscalId == 0">
                            <div class="col" *ngIf="persona.TipoPersona == 2">
                                <label>Ingreso Mensual</label>
                                <select class="form-control" name="IngresoId" [(ngModel)]="persona.Cliente.IngresoId"
                                    required #Ingresomensual="ngModel" [ngClass]="{ 'is-invalid':  Ingresomensual.errors?.required || Ingresomensual.value == -1,
                'is-valid': !Ingresomensual.errors?.required || Ingresomensual.value != -1}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ ingreso.ingresoId }}" *ngFor="let ingreso of ingresos">
                                        {{ ingreso.rangoIni | currency : 'MXN'}} -
                                        {{ ingreso.rangoFin | currency : 'MXN'}}</option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf="Ingresomensual.errors?.required || Ingresomensual.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>
                            <div class="col" *ngIf="persona.TipoPersona == 2">
                                <label for="exampleSelect1">Antigüedad</label>
                                <select class="form-control" id="exampleSelect1"
                                    [(ngModel)]="persona.Cliente.AntiguedadId" name="AntiguedadId" required
                                    #antiguedad="ngModel" [ngClass]="{ 'is-invalid':  antiguedad.errors?.required || antiguedad.value == -1,
                'is-valid': !antiguedad.errors?.required || antiguedad.value != -1}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ antiguedad.antiguedadId }}"
                                        *ngFor="let antiguedad of antiguedades">{{ antiguedad.rangoIni }} -
                                        {{ antiguedad.rangoFin }}</option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf="antiguedad.errors?.required || antiguedad.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>
                            <div class="col" *ngIf="persona.TipoPersona == 1">
                                <label for="sucursal">Sucursal</label>
                                <select class="form-control" name="SucursalId" [(ngModel)]="persona.Empleado.SucursalId"
                                    required #sucursal="ngModel" [ngClass]="{ 'is-invalid':  sucursal.errors?.required || sucursal.value == -1,
                'is-valid': !sucursal.errors?.required || sucursal.value != -1}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ sucursal.sucursalId }}" *ngFor="let sucursal of sucursales">
                                        {{ sucursal.sucursal }}</option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf=" sucursal.errors?.required || sucursal.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>

                            <div class="col" *ngIf="persona.TipoPersona == 2">
                                <label for="sucursal">Sucursal</label>
                                <select class="form-control" name="SucursalId" [(ngModel)]="persona.Cliente.SucursalId"
                                    required #sucursal="ngModel" [ngClass]="{ 'is-invalid':  sucursal.errors?.required || sucursal.value == -1,
              'is-valid': !sucursal.errors?.required || sucursal.value != -1}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ sucursal.sucursalId }}" *ngFor="let sucursal of sucursales">
                                        {{ sucursal.sucursal }}</option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf=" sucursal.errors?.required || sucursal.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>

                            <div class="col" *ngIf="persona.TipoPersona == 1">
                                <label for="area">Área</label>
                                <select class="form-control" name="AreaId" [(ngModel)]="persona.Empleado.AreaId"
                                    required #area="ngModel" [ngClass]="{ 'is-invalid':  area.errors?.required || area.value == -1,
                'is-valid': !area.errors?.required || area.value != -1}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ area.areaId }}" *ngFor="let area of areas">{{ area.area }}
                                    </option>
                                </select>
                                <div class="invalid-feedback" *ngIf="area.errors?.required || area.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>
                            <div class="col" *ngIf="persona.TipoPersona == 1">
                                <div class="form-group">
                                    <label>Puesto</label>
                                    <select class="form-control" name="PuestoId" [(ngModel)]="persona.Empleado.PuestoId"
                                        required #puesto="ngModel" [ngClass]="{ 'is-invalid':  puesto.errors?.required || puesto.value == -1,
                'is-valid': !puesto.errors?.required || puesto.value != -1}">
                                        <option value="-1">Selecciona una Opción</option>
                                        <option value="{{ puesto.puestoId }}" *ngFor="let puesto of puestos">
                                            {{ puesto.puesto }}</option>
                                    </select>
                                    <div class="invalid-feedback" *ngIf="puesto.errors?.required || puesto.value == -1">
                                        Debes Seleccionar una Opción
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div class="form-group row" *ngIf="persona.TipoPersona == 4">

                            <div class="col">
                                <div class="form-group">
                                    <label>Login</label>
                                    <input type="text" class="form-control" placeholder="Login"
                                        [(ngModel)]="persona.Usuario.Login" name="Login" />
                                </div>
                            </div>
                        </div>

                        <div class="form-group  row" *ngIf="persona.TipoPersona == 1">
                            <div class="col" *ngIf="persona.TipoPersona == 1">
                                <label for="contratacion">Contratación</label>
                                <select class="form-control" name="ContratacionId"
                                    [(ngModel)]="persona.Empleado.ContratacionId" requiered #contratacion="ngModel"
                                    [ngClass]="{ 'is-invalid':  contratacion.errors?.required || contratacion.value == -1,
                'is-valid': !contratacion.errors?.required || contratacion.value != -1}">
                                    <option value="-1">Selecciona una Opción</option>
                                    <option value="{{ contratacion.contratacionId }}"
                                        *ngFor="let contratacion of contrataciones">{{ contratacion.contratacion }}
                                    </option>
                                </select>
                                <div class="invalid-feedback"
                                    *ngIf="contratacion.errors?.required || contratacion.value == -1">
                                    Debes Seleccionar una Opción
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Profesión</label>
                                    <input type="text" class="form-control" maxlength="50" placeholder="Profesión" name="Profesion"
                                        [(ngModel)]="persona.Empleado.Profesion" required #profesion="ngModel"
                                        [ngClass]="{ 'is-invalid':  profesion.errors?.required ,
                'is-valid': !profesion.errors?.required }" />

                                    <div class="invalid-feedback" *ngIf="profesion.errors?.required">
                                        Debes llenar este campo
                                    </div>

                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Estatura (cm)</label>
                                    <input type="text" class="form-control" placeholder="Estatura" name="Estatura"  (keyup)="validarEstatura()"
                                         pattern="^(\d*\.)?\d+$"
                                        [(ngModel)]="persona.Empleado.Estatura" required #estatura="ngModel" [ngClass]="{ 'is-invalid':  estatura.errors?.required|| estatura.errors?.pattern  || errorEstatura,
                'is-valid': !estatura.errors?.required }" />

                                    <div class="invalid-feedback" *ngIf="estatura.errors?.required">
                                        Debes llenar este campo
                                    </div>
                                    <div class="invalid-feedback" *ngIf="estatura.errors?.pattern">
                                      El formato es incorrecto
                                  </div>
                                  <div class="invalid-feedback" *ngIf="errorEstatura">
                                    La estatura no debe de ser mayor de 999.99
                                </div>
                                </div>
                            </div>
                        </div>

                        <h4 class="sub-title" *ngIf="persona.TipoPersona == 2">
                            Tipo de Lista
                        </h4>
                        <div class="row">
                            <div class="col" *ngIf="persona.TipoPersona == 2">
                                <div class="checkbox-fade fade-in-primary">
                                    <label>
                                        <input type="checkbox" value="" [(ngModel)]="persona.Persona.EsPEP"
                                            name="EsPEP" />
                                        <span class="cr">
                                            <i class="cr-icon icofont icofont-ui-check txt-primary"></i>
                                        </span>
                                        <span>¿Es PEP?</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col" *ngIf="persona.TipoPersona == 2">
                                <div class="checkbox-fade fade-in-primary">
                                    <label>
                                        <input type="checkbox" value="" [(ngModel)]="persona.Persona.RelacionPEP"
                                            name="RelacionPEP" />
                                        <span class="cr">
                                            <i class="cr-icon icofont icofont-ui-check txt-primary"></i>
                                        </span>
                                        <span>¿Relacionado con PEP?</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col" *ngIf="persona.TipoPersona == 2">
                                <div class="checkbox-fade fade-in-primary">
                                    <label>
                                        <input type="checkbox" value="" [(ngModel)]="persona.Persona.EsLN"
                                            name="EsLN" />
                                        <span class="cr">
                                            <i class="cr-icon icofont icofont-ui-check txt-primary"></i>
                                        </span>
                                        <span>¿Lista Negra?</span>
                                    </label>
                                </div>
                            </div>

                            <div class="col" *ngIf="persona.TipoPersona == 1">
                                <div class="checkbox-fade fade-in-primary">
                                    <label>
                                        <input type="checkbox" value="" [(ngModel)]="persona.Empleado.Titulado"
                                            name="Titulado" />
                                        <span class="cr">
                                            <i class="cr-icon icofont icofont-ui-check txt-primary"></i>
                                        </span>
                                        <span>¿Titulado?</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col" *ngIf="persona.TipoPersona == 1">
                                <div class="checkbox-fade fade-in-primary">
                                    <label>
                                        <input type="checkbox" value="" [(ngModel)]="persona.Empleado.Comite"
                                            name="Comite" />
                                        <span class="cr">
                                            <i class="cr-icon icofont icofont-ui-check txt-primary"></i>
                                        </span>
                                        <span>¿Comité?</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col" *ngIf="persona.TipoPersona == 1">
                                <div class="checkbox-fade fade-in-primary">
                                    <label>
                                        <input type="checkbox" value=""
                                            [(ngModel)]="persona.Empleado.OficialCumplimiento"
                                            name="OficialCumplimiento" />
                                        <span class="cr">
                                            <i class="cr-icon icofont icofont-ui-check txt-primary"></i>
                                        </span>
                                        <span>¿Cumplimiento?</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="text-right">
                            <button type="submit" class="btn btn-info" [disabled]="!formPersona.valid">
                                Guardar
                            </button>
                        </div>
                    </form>
                </div>
                <!-- Form Search End  -->
            </div>
            <!-- Both borders table end -->
        </div>
    </div>
    <!-- Page body end -->
</div>
